module.exports = __webpack_public_path__ + "static/media/ausnet.aea3b9f8.png";